import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const VIDEOS = {
  es: "https://www.youtube-nocookie.com/embed/qoEClCemxu4",
  en: "https://www.youtube-nocookie.com/embed/rgm0vr3XkKw",
  de: "https://www.youtube-nocookie.com/embed/-qxdXaNNN1c",
};

const overlayAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.25 },
};

const contentAnimation = {
  initial: { scale: 0.92, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0.92, opacity: 0 },
  transition: { duration: 0.3 },
};

export default function VideoModal({ open, onClose, lang = "es" }) {
  const videoUrl = VIDEOS[lang] || VIDEOS.es;
  const isYoutube = videoUrl.includes("youtube");

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          {...overlayAnimation}
          data-testid="video-modal-overlay"
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 backdrop-blur-sm px-4"
          onClick={onClose}
        >
          <motion.div
            {...contentAnimation}
            data-testid="video-modal-content"
            className="relative w-full max-w-4xl rounded-2xl overflow-hidden bg-[#0a0f1f] shadow-2xl shadow-[#1a6cf5]/10"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={onClose}
              data-testid="video-modal-close"
              className="absolute top-4 right-4 z-10 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors"
            >
              <X size={20} />
            </button>
            {isYoutube ? (
              <iframe
                data-testid="video-player"
                className="w-full aspect-video"
                src={`${videoUrl}?autoplay=1`}
                title="MedSim Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                frameBorder="0"
              />
            ) : (
              <video
                data-testid="video-player"
                className="w-full aspect-video"
                controls
                autoPlay
                key={videoUrl}
                src={videoUrl}
              >
                Your browser does not support the video tag.
              </video>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
